import { render, staticRenderFns } from "./seller-orders.page.vue?vue&type=template&id=06707710&scoped=true"
import script from "./seller-orders.page.vue?vue&type=script&lang=js"
export * from "./seller-orders.page.vue?vue&type=script&lang=js"
import style0 from "./seller-orders.page.vue?vue&type=style&index=0&id=06707710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06707710",
  null
  
)

export default component.exports